import { css } from '@emotion/react';
var className = 'menu';
/**
 * We export the objects as well for compatibilty with 3rd party libs like react-select
 */
var baseStylesObject = {
  backgroundColor: 'var(--surface)',
  boxShadow: 'var(--elevation-small)',
  borderRadius: 'var(--border-radius-small)',
  padding: 'var(--spacing-l1)',
  zIndex: 'var(--zindex-layer)'
};
var baseStyles = /*#__PURE__*/css(baseStylesObject, process.env.NODE_ENV === "production" ? "" : ";label:baseStyles;");
export { baseStyles, baseStylesObject, className };
